export interface Terminal {
  id: string
  name: string
  locationCode: string
  address?: string
  totalAnsibles: number
  activeAnsibles: number
  status: TerminalStatus
  createdAt: string
  updatedAt: string
  ansibles?: import('./ansible').Ansible[]
}

export enum TerminalStatus {
  OPERATIONAL = 'OPERATIONAL',
  MAINTENANCE = 'MAINTENANCE',
  OFFLINE = 'OFFLINE',
}

export interface PaginatedTerminalResponse {
  data: Terminal[]
  meta: {
    total: number
    page: number
    limit: number
    totalPages: number
  }
}

export interface TerminalCountResponse {
  total: number
  byStatus: {
    [key in TerminalStatus]: number
  }
}
